import { render, staticRenderFns } from "./TimbresIlimitados.vue?vue&type=template&id=8295a83c&scoped=true"
import script from "./TimbresIlimitados.vue?vue&type=script&lang=js"
export * from "./TimbresIlimitados.vue?vue&type=script&lang=js"
import style0 from "./TimbresIlimitados.vue?vue&type=style&index=0&id=8295a83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8295a83c",
  null
  
)

export default component.exports